




















































































































import { Meta } from "@/store/meta"
import { Component } from "vue-property-decorator"
import { Server } from '@/store/server'
import { getModule } from "vuex-module-decorators"
import { mixins } from "vue-class-component"
import { DateTime } from "@/mixins/datetime"
@Component({
})
export default class Broadcast extends mixins(DateTime) {

  convertText(text: string, textLimit = 20){
    if (text.length > textLimit) {
      let shortText = ''
      shortText = text.substr(0, textLimit)
      shortText += '...'
      return shortText
    } else {
      return text
    }
  }

  loading = false

  get isLoading() {
    return this.loading
  }

  get isViewReady() {
    return this.server.BroadcastMessagesData.messages.length > 0
  }

  get total() {
    return this.server.BroadcastMessagesData.listing.total
  }

  get perPage() {
    return this.server.BroadcastMessagesData.listing.limit
  }

  async mounted() {
    this.loading = true
    try {
      if (this.xChannelServices.length == 0) {
        await this.server.getBoccoChannel()
      }
      await this.server.getBroadcastMessages()
    } catch (e) {
      return
    } finally {
      this.loading = false
    }
  }

  get meta() {
    return getModule(Meta)
  }
  get server() {
    return getModule(Server)
  }

  get broadcastEntries(){
    return this.server.BroadcastMessagesData.messages
  }

  get xChannelServices() {
    const channel = getModule(Server).boccoChannel
    return channel == null ? [] : channel.services
  }

  channelInfo(uuid: string) {
    const matchedChannels = this.xChannelServices.filter( channel => channel.uuid == uuid)
    if (matchedChannels.length == 0) {
      this.server.getBoccoChannel()
      return "Unknown"
    } else {
      return matchedChannels[0].name
    }
  }

  postLink(timing: string){
    this.$router.push({ path: '/messages/create' , query :{ timing: timing }});
  }

  detailLink(id: string){
    this.$router.push({ path: '/messages/' + id });
  }

  async onPageChanged(page: number) {
    const index = page - 1
    this.loading = true
    await this.server.getBroadcastMessages(index * this.perPage)
    this.loading = false
  }

}
